import { Dictionary } from '@/types';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FilterMixin extends Vue {
  get filterValues(): Dictionary<any> {
    return {
      ...this.$route.query,
      ...this.$route.params,
    };
  }

  get filterFields() {
    // тут фильтр вакансий
    const competences = this.$store.state.vacanciesList.competences;

    const competense = [
      {
        title: 'Компетенция',
        code: 'competence_id',
        data: [
          { name: 'Любая компетенция', id: '', default: true },
          ...competences,
        ],
        filterable: 'auto',
      },
    ];

    const professions = this.$store.state.vacanciesList.professions;

    const profession = [
      {
        title: 'Профессия',
        code: 'profession_id',
        data: [
          { name: 'Любая профессия', id: '', default: true },
          ...professions,
        ],
        filterable: 'auto',
      },
    ];

    const organizations = this.$store.state.vacanciesList.organizations;

    const organisation = [
      {
        title: 'Организация',
        code: 'partner_id',
        data: [
          { name: 'Любая организация', id: '', default: true },
          ...organizations,
        ],
        filterable: 'auto',
      },
    ];

    const minSalary = [
      {
        title: 'Минимальная зарплата',
        code: 'salary_min',
      },
    ];

    const maxSalary = [
      {
        title: 'Максимальная зарплата',
        code: 'salary_max',
      },
    ];

    const employmentTypes =
      this.$store.state.vacanciesList.vacanciesEmploymentType;

    const employmentType = [
      {
        title: 'Тип занятости',
        code: 'employment_type_id',
        data: [
          { name: 'Любой тип занятости', id: '', default: true },
          ...employmentTypes,
        ],
        filterable: 'auto',
      },
    ];

    const placeTypes = this.$store.state.vacanciesList.vacanciesPlaceType;

    const placeOfWork = [
      {
        title: 'Место работы',
        code: 'place_type',
        data: [
          { name: 'Любое место работы', id: '', default: true },
          ...placeTypes,
        ],
        filterable: 'auto',
      },
    ];

    const anotherSity = [
      {
        title: 'Из других городов',
        code: 'is_other_cities',
        data: [
          {
            name: 'Да',
            id: '1',
          },
          {
            name: 'Нет',
            id: '0',
          },
        ],
      },
    ];

    const ovz = [
      {
        title: 'Для лиц с ОВЗ',
        code: 'is_ovz',
        data: [
          {
            name: 'Да',
            id: '1',
          },
          {
            name: 'Нет',
            id: '0',
          },
        ],
      },
    ];
    const ret: any = [
      ...profession,
      ...organisation,
      ...minSalary,
      ...employmentType,
      ...placeOfWork,
    ];
    if (this.$store.getters.hasApiModulesMultiCop) {
      ret.push({
        title: 'Все цопп',
        code: 'cop_multi',
        data: [
          { name: 'Не выбрано', id: '', default: true },
          ...this.$store.state.copMultiDict,
        ],
      });
    }

    return [
      // ...competense,
      ...ret,
      ...anotherSity,
      ...ovz,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/pages/vacancies/mixins/filter-mixin.ts